import React, { useState } from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  TextField,
  ButtonGroup,
  makeStyles,
} from "@material-ui/core";

import Autocomplete from '@material-ui/lab/Autocomplete';
import t from "../common/localization";
import { useSelector } from "react-redux";
import moment from "moment";
import { useEffectAsync } from "./../reactHelper";


const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    // display: "flexEnd",
    flexDirection: "row",
    textAlign: "right",
    display:'flex',
    marginLeft:"90px"
  },
  content: {
    flex: 1,
    overflow: "auto",
    padding: theme.spacing(2),
  },
  form: {
    padding: theme.spacing(1, 2, 2),
  },
  button: {
    //  background: '#623DE6',
    border: 0,
    borderRadius: 15,
    boxShadow: "0 3px 5px 2px rgba(33, 203, 243, .3)",
    color: "white",
    height: 35,
    margin: 3,
    marginLeft: "-90px",
    marginTop: -1,
    // padding: '0 20px',
    width: 80,
    flexDirection: "row",
    primaryTextColor: 'white',
  },
  selectField: {
    textAlign: "left",
    color: 'white',
    height: "50px",
    variant: "outlined",
    margin: "5px",
    width:"20%",
  },
  selectField1: {
    textAlign: "left",
    color: 'white',
    height: "50px",
    variant: "outlined",
    margin: "5px",
    marginLeft: "-95px",
    width:"20%",
  },
  multipleAutoComplete: {
      // Hover
      '&[data-focus="true"]': {
        backgroundColor: '#b3aeae',
        borderColor: 'transparent',
        color:'black'
      },
      // Selected
      '&[aria-selected="true"]': {
        backgroundColor: '#361DDB',
        borderColor: 'transparent',
        color:'white',
      },
    },
     menuItemCss: {
          '&.Mui-selected': {
                background: "#361DDB",
                color:'white'
          },
          '&:hover': {
                background: "#b3aeae",
                color:'black'
          },
          "&:hover.Mui-selected": {
                        background: "#361DDB",
                        color: "white",
                      },
         },
  overrides: {
    MuiTableRow: {
      hover: {
        backgroundColor: "green",
      },
    },
  },
  rootG: {
    "& > *": {
      margin: theme.spacing(1),
    },
    border: 0,
  },
}));
const ChartReportFilter = ({ handleSubmit, showOnly, setType, type, reportHeader }) => {
  const devices = useSelector((state) => Object.values(state.devices.items));
  const [deviceId, setDeviceId] = useState("");
  const [period, setPeriod] = useState("today");
  // const [type, setType] = useState("");
  const [from, setFrom] = useState(moment().subtract(1, "hour"));
  const [to, setTo] = useState(moment());
  const classes = useStyles();
  const selectedId = useSelector(state => {
    if (state.devices.selectedId) {
      // setDeviceId(state.devices.selectedId);
      return state.devices.selectedId;

    }
    return null;
  });

  const handleClick = (mail, json) => {
    let selectedFrom;
    let selectedTo;
    switch (period) {
      case "today":
        selectedFrom = moment().startOf("day");
        selectedTo = moment().endOf("day");
        break;
      case "yesterday":
        selectedFrom = moment().subtract(1, "day").startOf("day");
        selectedTo = moment().subtract(1, "day").endOf("day");
        break;
      case "thisWeek":
        selectedFrom = moment().startOf("week");
        selectedTo = moment().endOf("week");
        break;
      case "previousWeek":
        selectedFrom = moment().subtract(1, "week").startOf("week");
        selectedTo = moment().subtract(1, "week").endOf("week");
        break;
      case "thisMonth":
        selectedFrom = moment().startOf("month");
        selectedTo = moment().endOf("month");
        break;
      case "previousMonth":
        selectedFrom = moment().subtract(1, "month").startOf("month");
        selectedTo = moment().subtract(1, "month").endOf("month");
        break;
      default:
        selectedFrom = from;
        selectedTo = to;
        break;
    }

    const accept = json
      ? "application/json"
      : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    handleSubmit(
      deviceId,
      selectedFrom.toISOString(),
      selectedTo.toISOString(),
      mail,
      { Accept: accept }
    );
  };

  useEffectAsync(async () => {
    setDeviceId(selectedId);
  }, []);

  return (
    <div className={classes.root}>
    <h4 style={{margin:'10px', display:'flex'}}>{(reportHeader || "Report")}</h4>

      <FormControl className={classes.selectField}>
        {/* <InputLabel shrink>{t('reportDevice')}</InputLabel> */}
        <Autocomplete
          id="tags-outlinedhhh"
          options={devices}
          getOptionLabel={(option) => option.name}
          classes={{
                  option: classes.multipleAutoComplete
                 }}
          // value={devices[0] || ""}
          filterSelectedOptions
          onChange={(e, value) => {
            setDeviceId(value && value.id);
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              InputProps={{...params.InputProps, disableUnderline: true}}
              // label={'Select Device '}
              placeholder="Select Vehicle"
              variant="standard"
            />
          )}
        />

        {/* <Select
          disableUnderline={true}
          value={deviceId || ""}
          onChange={(e) => setDeviceId(e.target.value)}
          displayEmpty
        >
          <MenuItem value="" disabled>
            Device
          </MenuItem>
          {devices.map((device) => (
            <MenuItem value={device.id} key={device.id}>
              {device.name}
            </MenuItem>
          ))}
        </Select> */}
      </FormControl>
      <FormControl className={classes.selectField}>
        {/* <InputLabel>{t('reportPeriod')}</InputLabel> */}
        <Select
          inputProps={{ "aria-label": "Without label" }}
          disableUnderline={true}
          value={period}
          onChange={(e) => setPeriod(e.target.value)}
        >
          <MenuItem className ={classes.menuItemCss} value="today">{t("reportToday")}</MenuItem>
          <MenuItem className ={classes.menuItemCss} value="yesterday">{t("reportYesterday")}</MenuItem>
          <MenuItem className ={classes.menuItemCss} value="thisWeek">{t("reportThisWeek")}</MenuItem>
          <MenuItem className ={classes.menuItemCss} value="previousWeek">{t("reportPreviousWeek")}</MenuItem>
          <MenuItem className ={classes.menuItemCss} value="thisMonth">{t("reportThisMonth")}</MenuItem>
          <MenuItem className ={classes.menuItemCss} value="previousMonth">{t("reportPreviousMonth")}</MenuItem>
          <MenuItem className ={classes.menuItemCss} value="custom">{t("reportCustom")}</MenuItem>
        </Select>
      </FormControl>
      {period === "custom" && (
        <TextField
          className={classes.selectField}
          InputProps={{ "aria-label": "Without label", disableUnderline: true }}
          type="datetime-local"
          value={from.format(moment.HTML5_FMT.DATETIME_LOCAL)}
          onChange={(e) =>
            setFrom(moment(e.target.value, moment.HTML5_FMT.DATETIME_LOCAL))
          }
          fullWidth
        />
      )}
      {period === "custom" && (
        <TextField
          className={classes.selectField}
           InputProps={{ "aria-label": "Without label", disableUnderline: true }}
          type="datetime-local"
          value={to.format(moment.HTML5_FMT.DATETIME_LOCAL)}
          onChange={(e) =>
            setTo(moment(e.target.value, moment.HTML5_FMT.DATETIME_LOCAL))
          }
          fullWidth
        />
      )}

      <FormControl className={classes.selectField} disabled={!deviceId}>
        <div className={classes.root}>
          <Button
            variant="contained"
            color={(!deviceId) ? 'default' : 'primary'}
            onClick={() => handleClick(false, true)}
            className={classes.button}
            disabled={!deviceId}
          >
            {t("reportShow")}
          </Button>
        </div>
      </FormControl>
      <FormControl  className={classes.selectField1}>
                  <Select
                  disableUnderline={true}
                  displayEmpty
                  value={type || ''}
                  onChange={e => setType(e.target.value)}>
                  <MenuItem disabled>
                   Chart Type
                   </MenuItem>
                    <MenuItem className ={classes.menuItemCss} value="speed">{t('positionSpeed')}</MenuItem>
                    <MenuItem className ={classes.menuItemCss} value="accuracy">{t('positionAccuracy')}</MenuItem>
                    <MenuItem className ={classes.menuItemCss} value="altitude">{t('positionAltitude')}</MenuItem>
                    <MenuItem className ={classes.menuItemCss} value="fuel">{t('fuel')}</MenuItem>
                    <MenuItem className ={classes.menuItemCss} value="temp1">{t('positionTemp1')}</MenuItem>
                    <MenuItem className ={classes.menuItemCss} value="temp2">{t('positionTemp2')}</MenuItem>
                    <MenuItem className ={classes.menuItemCss} value="mtCustom1">{t('mtCustom1')}</MenuItem>
                    <MenuItem className ={classes.menuItemCss} value="mtCustom2">{t('mtCustom2')}</MenuItem>
                  </Select>
                </FormControl>
    </div>
  );
};

export default ChartReportFilter;
